//TODO: 추후 삭제
// TODO:  참고로 이건 참고해야하므로 아직 삭제하면 안됨.

import { useState, useEffect, useCallback } from 'react';
import GridAtom from '@components/atom/grid/grid';
import { QueryHookParam, useQueryDummyHook } from '@utils/hook/useQueryHook';
import { LoginOption } from '@classes/options/grid/account/loginGridOption';
import { loginFilterType } from '@models/manager/account/accountModel';
import { useSelector } from 'react-redux';
import { RootState } from '@reducers/index';

const LoginMonitor = () => {
  const { userInfo } = useSelector(({ auth }: RootState) => auth);
  const [gridChartOption, setGridChartOption] = useState(null);

  // 현재 입력된 검색조건들 {searchText: string. type: 'null'|'member'|'pageName'|'pageUrl'}
  const [searchObj, setSearchObj] = useState<loginFilterType>({ searchText: '', type: 'null' });
  // 필터링을 위한 filterObj {searchText: string, type: 'null'|'member'|'pageName'|'pageUrl'} // 개별로 들어감
  const [filterObj, setFilterObj] = useState(null);

  // create option
  const _option = new LoginOption();

  // useQuery to get loginMonitorData
  const loginQueryParams: QueryHookParam = {
    key: ['accountManager_loginMonitor'],
    url: '/api/account/loginMonitor.json',
    params: userInfo,
    method: 'GET',
    enabled: userInfo !== null,
  };
  const { data: loginMonitorList } = useQueryDummyHook(loginQueryParams);

  // useEffect for responseData
  useEffect(() => {
    if (loginMonitorList) {
      setGridChartOption(_option.loginMonitor(loginMonitorList));
    }
  }, [loginMonitorList]);

  // useEffect for change SelectOptions
  useEffect(() => {
    if (loginMonitorList) {
      if (filterObj) {
        setGridChartOption(_option.loginMonitor(loginMonitorList, filterObj));
      }
    }
  }, [filterObj]);

  // onChangeHandler
  const onChangeHandler = useCallback((event) => {
    const { name, value } = event.target;
    if (name === 'type') {
      setSearchObj((prev) => ({ ...prev, type: value }));
    } else {
      setSearchObj((prev) => ({ ...prev, searchText: value }));
    }
  }, []);

  // onClickLogSearchHandler
  const onClickLogSearch = useCallback(() => {
    if (searchObj.searchText.trim().length === 0) {
      alert('Text is required for log search');
    }
    setFilterObj(searchObj);
  }, [searchObj]);

  return (
    <>
      <h2 className="account-tit">Use Monitor</h2>
      <form>
        <div className="serach-box">
          <label className="select">
            <select name="type" onChange={onChangeHandler}>
              <option value="null">Search Type</option>
              <option value="member">Member email</option>
              <option value="pageName">Page Name</option>
              <option value="pageUrl">Page Url</option>
            </select>
          </label>
          <label className="ipt">
            <input
              type="text"
              placeholder=""
              value={searchObj.searchText}
              name="searchText"
              onChange={onChangeHandler}
            />
          </label>
          <button type="button" className="btn-s pri" onClick={onClickLogSearch}>
            Log Search
          </button>
        </div>
      </form>
      <div className="tb-basic-wrap">
        <GridAtom {...gridChartOption} height={'600px'} />
      </div>
    </>
  );
};

export default LoginMonitor;
